import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "m-4 flex"
}
const _hoisted_3 = { class: "flex items-center text-3xl" }
const _hoisted_4 = { class: "flex items-center ml-4" }
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "text-lg font-bold"
}
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "ml-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "m-2 p-2 border-2 flex-none md:flex md:justify-around" }
const _hoisted_17 = { class: "w-full md:w-12" }
const _hoisted_18 = { class: "block md:hidden" }
const _hoisted_19 = { class: "hidden md:block" }
const _hoisted_20 = { class: "w-full md:w-40" }
const _hoisted_21 = { class: "block md:hidden" }
const _hoisted_22 = { class: "hidden md:block" }
const _hoisted_23 = { class: "w-full md:w-12" }
const _hoisted_24 = { class: "block md:hidden" }
const _hoisted_25 = { class: "hidden md:block" }
const _hoisted_26 = { class: "w-full md:w-12" }
const _hoisted_27 = { class: "block md:hidden" }
const _hoisted_28 = { class: "hidden md:block" }
const _hoisted_29 = { class: "w-full md:w-12" }
const _hoisted_30 = { class: "block md:hidden" }
const _hoisted_31 = { class: "hidden md:block" }
const _hoisted_32 = { class: "w-full md:w-12" }
const _hoisted_33 = { class: "black md:hidden" }
const _hoisted_34 = { class: "hidden md:block" }
const _hoisted_35 = { class: "w-full md:w-12" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "mt-16" }
const _hoisted_39 = { class: "m-4" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "w-full" }
const _hoisted_42 = { class: "w-128" }
const _hoisted_43 = { class: "ml-4" }

import { useStore } from "vuex";
// import { useRoute, useRouter } from "vue-router";
import * as Vue from "vue";
// import { Icon } from "@iconify/vue";
// import { VERSION, BUILD_DATE } from "@/ver";
// import moment from "moment";
// import im2 from "@/components/Img2.vue";
import * as Helper from "@/helper";
import * as Types from "@/types";
// import { Adsense } from "vue3-google-adsense";
import * as Use from "@vueuse/core";

interface TODOS {
  todo: number;
  done: number;
}

interface PAGE {
  loading: boolean;
  error: string;
  list: Types.T_DEVICE[];
  sort_v: number;
  sort_desc: string;
  //
  report_use: boolean;
  report_item: Types.T_DEVICE | null;
  report_input: string;
  report_error: string;
  //
  todos: undefined | TODOS;
}

const SORT_HASH_WATT_PRICE = 0;
const SORT_HASH_WATT = 1;
const SORT_HASH_PRICE = 2;
// const sort_desc = Vue.ref("");

// 3 자리 마다 콤마, 소수점 없음음

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// src\views\HomeView.vue
const URL_HEAD = Types.get_url_head();

// const route = useRoute();
// const router = useRouter();
const store = useStore();
const is_dark = Use.useDark();

const ui_report_input = Vue.ref<HTMLInputElement | null>(null);
const page = Vue.ref<PAGE>({
  loading: true,
  error: "",
  list: [] as Types.T_DEVICE[],
  sort_v: 0,
  sort_desc: "",
  //
  report_use: false,
  report_item: null,
  report_input: "",
  report_error: "",
});

// const device_sort_v = Vue.ref(0);
// const device_list_wait = Vue.ref(true);
// const device_list_error = Vue.ref(false);
// const device_list = Vue.ref<Types.T_DEVICE[]>([]);

const num_comma = (n: number | undefined, point: number = 0) => {
  if (n === undefined) {
    return "?";
  }

  var str = n.toLocaleString("ko-KR");
  var full = str;

  // 소수점 자르기 작업
  var pos = str.indexOf(".");
  if (pos <= 0) return str;

  if (point == 0) {
    return str.substring(0, pos);
  }

  pos += 1;
  var left = str.length - pos;
  // console.log("num_comma", full, point, left);
  if (point >= left) return str;

  return str.substring(0, pos + point);
};

//
const todos_percent = Vue.computed(() => {
  if (page.value.todos === undefined) return "--%";

  var a = page.value.todos.todo;
  if (a === undefined) a = 0;
  var b = page.value.todos.done;
  if (b === undefined) b = 0;

  var c = (b / (a + b)) * 100;
  c = Math.round(c);
  // console.log("todos_percent", a, b, c);

  return `${c}%`;
});

//
const textarea_class = Vue.computed(() => {
  console.log("textarea_class", is_dark.value);
  if (is_dark.value) {
    return "tw_textarea_dark";
  }
  return "tw_textarea";
});

Vue.onMounted(async () => {
  console.log("proc_mount start");
  page.value.loading = true;
  page.value.error = "";
  page.value.list = [];
  // device_list_wait.value = true;

  try {
    const url = URL_HEAD + "/bitaxe/all_device";
    const res = await Helper.web_get(url);
    // console.log("res", url, res.data);

    // device_list_wait.value = false;
    if (res.data.code != 200) {
      console.error("res.data fail", res.data);
      // device_list_error.value = true;

      page.value.loading = false;
      page.value.error = "loading_fail";
      return;
    }

    console.log("res ok", res.data);

    const list = res.data.list as Types.T_DEVICE[];
    // for (var i in list) {
    //   const v = list[i];
    //   v.hash_watt = v.hashrate / v.watt;
    //   v.hash_watt_price = v.hash_watt / v.price;
    // }
    page.value.list = list;
    onSort(SORT_HASH_WATT_PRICE);

    // 개발용 데이터
    if (Helper.is_dev()) {
      page.value.todos = {
        todo: 10,
        done: 10,
      };
    }

    // todos 정보가 있다.
    if (res.data.todos !== undefined) {
      page.value.todos = res.data.todos as TODOS;
    }

    // console.log("store.state.count", store.state.count);
    store.commit("device_list", list);
  } catch (err) {
    const e = err as Error;
    console.error("req fail", e.message);
    // device_list_wait.value = false;
    // device_list_error.value = true;

    page.value.error = "loading fail";
  }

  page.value.loading = false;
});

function onSort(v: number) {
  console.log("onSort", v);

  var list = page.value.list;
  page.value.sort_v = v;

  if (v == SORT_HASH_WATT_PRICE) {
    console.log("sort SORT_HASH_WATT_PRICE");

    page.value.sort_desc = "성능 & 소비전력 & 가격을 종합한 순위 입니다.";

    // 기준 점수
    const r_hash = 100;
    const r_watt = 0.5;
    const r_price = 10000;
    for (const data of list) {
      var price = data.price / r_price;
      var per_hash = (data.hashrate / price) * r_hash;
      var per_watt = (data.watt / price) * r_watt;
      var total = per_hash;
      total += per_watt;
      total *= 1000;
      data.rank_point = total;
      data.temp = `${per_hash.toFixed(3)} / ${per_watt.toFixed(3)}`;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
    });
  } else if (v == SORT_HASH_WATT) {
    console.log("sort SORT_HASH_WATT");
    page.value.sort_desc = "성능과 전력소비 만 고려한 순위입니다. (가격 제외)";

    // 기준 점수
    for (const data of list) {
      data.rank_point = data.hashrate / data.watt;
      data.rank_point *= 1_000_0;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
      // // 해시 높은 순
      // if (a.hashrate > b.hashrate) return -1;
      // if (a.hashrate < b.hashrate) return 1;
      // return 0;
    });
  } else if (v == SORT_HASH_PRICE) {
    console.log("sort SORT_HASH_PRICE");
    page.value.sort_desc = "성능과 가격 만 고려한 순위입니다. (소비전력 제외)";

    // 기준 점수
    for (const data of list) {
      data.rank_point = data.hashrate / data.price;
      data.rank_point *= 10_000_000;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
      // // 해시 높은 순
      // if (a.hashrate > b.hashrate) return -1;
      // if (a.hashrate < b.hashrate) return 1;
      // return 0;
    });
  }

  console.log("list", list);

  // // 최고전수
  // var max_point = 0;
  // for (const data of list) {
  //   const n = data.rank_point as number;
  //   if (n < max_point) continue;
  //   max_point = n;
  // }

  // // 환
  // for (const data of list) {
  //   const n = data.rank_point as number;
  //   // data.rank_point = Math.round((n / max_point) * 100);
  //   data.rank_point = Math.round(n * 10000);
  // }

  let rank = 0;
  list.forEach((r) => {
    rank++;
    r.rank = rank;
  });
  console.log("onSort", v, list);
  // device_list.value = list;
  // device_sort_v.value = v;
  page.value.list = list;
}

// const onDetail = (uid: number) => {
//   console.log("onDetail", uid);
//   router.push("/detail/" + uid);
// };

// 선택되었나?
const IsSort = (v: number) => {
  return v == page.value.sort_v;
};

// 표시할 class
const classSort = (v: number) => {
  // return v == device_sort_v.value ? "sort_on" : "sort_off";
  return v == page.value.sort_v ? "sort_on" : "sort_off";
};

// 제보하러가기기
const onReportGo = (data: Types.T_DEVICE) => {
  console.log("onReport", data);

  page.value.report_use = true;
  page.value.report_item = data;
  page.value.report_input = "";
  if (ui_report_input.value == null) {
    console.log("ui is null");
  } else {
    // console.log("ui is good");
    ui_report_input.value.focus();
  }
};

// 제보 전송
const onReportSend = async () => {
  var val = page.value;
  console.log("onReportSend start", val.report_item, val.report_input);

  // 전송하기
  val.report_error = "전송중";

  let device_uid = 0;
  let content = "---\n" + val.report_input;
  if (val.report_item) {
    device_uid = val.report_item.uid;
    content = val.report_item.name + "\n" + content;
  }

  try {
    const url = URL_HEAD + "/bitaxe/report_write";
    const res = await Helper.web_post(url, {
      body: {
        device_uid,
        content,
      },
    });

    const data = res.data;
    console.log("data", data);

    if (data.code != 200) {
      throw new Error("code fail, " + data.code);
    }

    // page.value.report_use = false;
    val.report_item = null;
    val.report_input = "";
    val.report_error = "✔️ 전송 완료";
  } catch (err) {
    const e = err as Error;
    console.error("req fail", e.message);
    val.report_error = "❌ 전송 실패, " + e.message;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (Helper.is_dev())
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "DEV " + _toDisplayString(_unref(URL_HEAD)), 1))
      : _createCommentVNode("", true),
    _cache[27] || (_cache[27] = _createElementVNode("h2", null, "장비 리스트 - ⚠️ 순위 방식 조정 중입니다. 의견 주세요", -1)),
    (_unref(page).todos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "진행율 " + _toDisplayString(_unref(todos_percent)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, "처리중: " + _toDisplayString(_unref(page).todos.todo), 1),
            _createElementVNode("span", _hoisted_5, "완료: " + _toDisplayString(_unref(page).todos.done), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(page).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "불러오는중..."))
      : (_unref(page).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "불러오기 실패했습니다. (" + _toDisplayString(_unref(page).error) + ")", 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(classSort(SORT_HASH_WATT_PRICE)),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onSort(SORT_HASH_WATT_PRICE)))
                }, [
                  (IsSort(SORT_HASH_WATT_PRICE))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "✔️"))
                    : _createCommentVNode("", true),
                  _cache[4] || (_cache[4] = _createTextVNode(" 종합 ")),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _cache[6] || (_cache[6] = _createTextVNode(" (성능 / 소비전력 / 가격) "))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: _normalizeClass(classSort(SORT_HASH_WATT)),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onSort(SORT_HASH_WATT)))
                }, [
                  (IsSort(SORT_HASH_WATT))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "✔️"))
                    : _createCommentVNode("", true),
                  _cache[7] || (_cache[7] = _createTextVNode(" 전성비 ")),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                  _cache[9] || (_cache[9] = _createTextVNode(" (성능 / 소비전력) "))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: _normalizeClass(classSort(SORT_HASH_PRICE)),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onSort(SORT_HASH_PRICE)))
                }, [
                  (IsSort(SORT_HASH_PRICE))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "✔️"))
                    : _createCommentVNode("", true),
                  _cache[10] || (_cache[10] = _createTextVNode(" 가성비 ")),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _cache[12] || (_cache[12] = _createTextVNode(" (성능 / 가격) "))
                ], 2)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).list, (data) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data.uid
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString("순위: " + data.rank), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(data.rank) + ". ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString("제품명: " + data.name), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(data.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createTextVNode(_toDisplayString("점수: " + num_comma(data.rank_point)) + " ", 1),
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "tw_unit" }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_25, [
                      _createTextVNode(_toDisplayString(num_comma(data.rank_point)) + " ", 1),
                      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "tw_unit" }, "점수", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createTextVNode(_toDisplayString("성능: " + data.hashrate) + " ", 1),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "tw_unit" }, "TH/s", -1))
                    ]),
                    _createElementVNode("span", _hoisted_28, [
                      _createTextVNode(_toDisplayString(data.hashrate) + " ", 1),
                      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "tw_unit" }, "TH/s", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createTextVNode(_toDisplayString("소비전력: " + data.watt) + " ", 1),
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "tw_unit" }, "W/h", -1))
                    ]),
                    _createElementVNode("span", _hoisted_31, [
                      _createTextVNode(_toDisplayString(data.watt), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "tw_unit" }, "W/h", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createTextVNode(_toDisplayString("가격: " + num_comma(data.price / 10000, 1)) + " ", 1),
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "tw_unit" }, "만원", -1))
                    ]),
                    _createElementVNode("span", _hoisted_34, [
                      _createTextVNode(_toDisplayString(num_comma(data.price / 10000, 1)) + " ", 1),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "tw_unit" }, "만원", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (onReportGo(data))
                    }, _cache[25] || (_cache[25] = [
                      _createElementVNode("div", { class: "text-sm" }, "의견쓰기", -1)
                    ]), 8, _hoisted_36)
                  ])
                ]),
                (Helper.is_dev())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, "DEV: 계산식 " + _toDisplayString(data.temp), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_38, [
              _cache[26] || (_cache[26] = _createElementVNode("h3", null, "의견 전송", -1)),
              _createElementVNode("div", _hoisted_39, [
                (_unref(page).report_item)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(page).report_item.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "ui_report_input",
                      ref: ui_report_input,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(page).report_input) = $event)),
                      type: "text",
                      placeholder: "내용 입력해주세요...",
                      class: _normalizeClass(_unref(textarea_class))
                    }, null, 2), [
                      [_vModelText, _unref(page).report_input]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", { onClick: onReportSend }, "전송하기"),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(page).report_error), 1)
                ])
              ])
            ])
          ]))
  ]))
}
}

})